export default __webpack_public_path__ + "static/media/defaultProfileImage.939a0496.png";